"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.defaultProps = exports.Tag = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Icons = require("../../foundation/Icons");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Tag = function Tag(props) {
  var classNames = props.classNames,
      children = props.children,
      onClick = props.onClick; // ADA compliant - allow an enter key to act like a click.

  var _handleKeyPress = function _handleKeyPress(target) {
    if (target.key === 'Enter') {
      target.currentTarget.click();
    }
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('tag', classNames),
    role: "button",
    onClick: onClick,
    tabIndex: 0,
    onKeyDown: _handleKeyPress
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "tag__content"
  }, children), /*#__PURE__*/_react.default.createElement("div", {
    className: "tag__close_icon_container"
  }, /*#__PURE__*/_react.default.createElement(_Icons.IcoTimes, {
    className: "tag__close_icon"
  })));
};

exports.Tag = Tag;
Tag.propTypes = {
  classNames: _propTypes.default.any.isRequired,
  onClick: _propTypes.default.func.isRequired,
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.arrayOf(_propTypes.default.node)]).isRequired
};
var defaultProps = {
  classNames: {},
  onClick: function onClick() {},
  children: null
};
exports.defaultProps = defaultProps;
Tag.defaultProps = defaultProps;
Tag.displayName = 'Tag';
var _default = Tag;
exports.default = _default;